import React from "react";
import { ArrowRightIcon } from "lucide-react";
const footerLinks = [{
  label: "Look inside",
  href: "#preview"
}, {
  label: "Workshops",
  href: "#workshops"
}, {
  label: "Bonuses",
  href: "#bonuses"
}, {
  label: "Pricing",
  href: "#offer-details"
}, {
  label: "FAQ",
  href: "#faq"
}];
export function SiteFooter() {
  return <footer className="site-footer" data-id="element-224" data-mp="3hhwvjo2kpedz">
      <div className="shell" data-id="element-225" data-mp="3dgutkzh9uo8b">
        <a href="#top" className="footer-brand" data-id="element-226" data-mp="3dh4kcpa54zf2">
          SALES TEAM PRACTICE <span data-id="element-227" data-mp="38hrppid12o1x">READY</span>
        </a>
        <p data-id="element-228" data-mp="38gqar2sw5hex">Volume 1: five ready-to-run sales conversation workshops for sales team leaders.</p>
        <nav aria-label="Footer" data-id="element-229" data-mp="33jq52szyegoc">
          {footerLinks.map(link => <a key={link.href} href={link.href} data-id="element-230" data-mp="2yju3t1in53ch">
              {link.label}
            </a>)}
          <a href="#offer-details" className="store-link" data-id="element-231" data-mp="11rtvvq19diwq">
            See the complete offer <ArrowRightIcon size={13} aria-hidden="true" data-id="element-232" data-mp="ws7gb9xyjqkr" />
          </a>
        </nav>
        <p className="footer-small" data-id="element-233" data-mp="wqea1vr9b8da">English-language PDFs · Internal-team use · Store in preparation</p>
      </div>
    </footer>;
}